import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.304 2.14a.66.66 0 0 0-.293.438.61.61 0 0 0 .143.494L9.353 8l-4.2 4.928a.61.61 0 0 0-.142.494.66.66 0 0 0 .293.438q.12.083.267.118a.84.84 0 0 0 .578-.073.7.7 0 0 0 .22-.178l4.438-5.208A.8.8 0 0 0 11.004 8c0-.188-.07-.37-.197-.52L6.368 2.274a.7.7 0 0 0-.22-.178.8.8 0 0 0-.577-.073.8.8 0 0 0-.267.118",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }